/**
 * Centralized viewport breakpoints. Keep these in sync with `tailwind.config.js`
 * `theme.screens` — duplicating the values would risk drift between JS-side
 * matchMedia checks and Tailwind's responsive utilities.
 */
export const LG_BREAKPOINT_PX = 1024;
export const LG_BREAKPOINT_QUERY = `(min-width: ${LG_BREAKPOINT_PX}px)` as const;
